module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAPFBMVEUAAAD////////////////////////////////////////////////////////////////////////////YSWgTAAAAE3RSTlMAoL8gcO/fQGCQEI+AXzDPf1AfAfEb1QAAAMVJREFUOMvdlEkOwyAMRcHGQEiTDv/+dy2NoqY0Iba67Nsw6MniC4P7lcQ27w6xmQmgZXILiklAqkMGHpaSHBGdpeQI5K7Bwb8ggDwgyyLsk82EQ+hLnQQ9mvgBJ0ybx4I+n1fgcQq9C0KhrGLGipZngMJgOyLgj8TIPCjiFpG9TazkaBMrpJ6xuVVdTNEmBj2M1I0yQhdRHF9hEeMo6IjB2hQJCvP2RE+JzllKNk980LtRb0nvGi4dTcLuR8kkO4suxf0jT2EiOjVsey43AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/new/game/game-tab2-active.png
// module id = CJ+3
// module chunks = 1